import React from 'react'
import { Label } from '@/components/ui/label'
import ManagerFilter from '../../manager_filter'
import store from '../../../state/store'

class EditManager extends React.Component {

  onChange = (value) => {
    if (value === '') {
      return
    }

    store.emit('enquiry:update_manager', this.props.enquiry.id, value)
  }

  render() {
    const enquiry = this.props.enquiry

    return (
      <div className="flex items-center justify-end gap-2">
        <Label className="shrink-0">LS:</Label>
        <div className="w-56">
          <ManagerFilter
            managers={enquiry.manager_options}
            selected={enquiry.manager}
            placeholder="Unclaimed"
            can_unset={false}
            disabled={enquiry.handed_over}
            onChange={this.onChange}
          />
        </div>
      </div>
    )
  }
}

export default EditManager
